import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ShareButton from '../ShareButton'

function NavbarV2() {
  const [isScrolled, setIsScrolled] = useState(false)

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={`navbar z-[100] bg-[#095393] sticky top-0 shadow-sm border-b border-white ${isScrolled ? 'shadow-md' : ''}`}>
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex w-full items-center justify-between">
          {/* Logo Section */}
          <Link to="https://perumdamavo.id" className="flex items-center gap-2 flex-shrink-0">
            <img 
              src="/assets/img/logo-app-avo.png" 
              className="w-[40px] md:w-[50px]" 
              alt="logo" 
            />
            <div className="flex flex-col">
              <span className="text-white text-sm md:text-base font-semibold leading-tight">
                PERUMDAM AVO
              </span>
              <span className="text-white text-xs md:text-sm font-normal leading-tight">
                Kota Palu
              </span>
            </div>
          </Link>

          {/* Menu Section - Desktop */}
          {/* <div className="hidden md:flex items-center gap-2">
            <div className="dropdown dropdown-end">
              <div tabIndex={0} role="button" className="btn btn-ghost text-white hover:bg-white/10">
                <span>Menu</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow-lg border border-gray-200">
                <li><Link to="/v2/info-tagihan" className="text-gray-700">Info Tagihan</Link></li>
                <li><Link to="/v2/info-tagihan" className="text-gray-700">Riwayat Pembayaran</Link></li>
                <li><Link to="/v2/info-tagihan" className="text-gray-700">Bantuan</Link></li>
                <li className="divider my-1"></li>
                <li><Link to="/v2/info-tagihan" className="text-gray-700">Tentang Kami</Link></li>
              </ul>
            </div>
            
            <button className="btn btn-ghost text-white hover:bg-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
            
            <button className="btn btn-ghost text-white hover:bg-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>
          </div> */}

          {/* Right Side Actions */}
          <div className="flex items-center gap-1">
            <ShareButton />
            <div className="md:hidden">
              <label htmlFor="drawer-v2" className="btn btn-ghost text-white drawer-button">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavbarV2

